module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_chikamori-e3ba229df4e1c46643df0e0da28e99e7.jpg";